import { createSlice } from "@reduxjs/toolkit";
import { SchedulesType } from "../../../../types/Project";

const initialState: SchedulesType = {
  acquisition: [
    { name: "Closing", date: "" },
    { name: "Contract Execution", date: "" },
    { name: "Due Deligence Ends", date: "" },
  ],
  finance: [
    { name: "Term Sheets Received", date: "" },
    { name: "Commitment Letter Executed", date: "" },
    { name: "Financial Close", date: "" },
  ],
  procurement: [
    { name: "Release Requests", date: "" },
    { name: "Receive Proposals", date: "" },
    { name: "Make Awards", date: "" },
    { name: "Negotiate Contracts", date: "" },
    { name: "Execute Contracts", date: "" },
  ],
  development: [
    { name: "Business Plan Finalized", date: "" },
    { name: "Listing Agent Agreement", date: "" },
    { name: "Construction Contract Executed", date: "" },
  ],
  design: [
    { name: "Scope of Work Finalized", date: "" },
    { name: "Schematic Set", date: "" },
    { name: "Development Document Set", date: "" },
    { name: "Construction Document Set", date: "" },
    { name: "Permits Obtained", date: "" },
  ],
  construction: [
    { name: "Kick-OFF Meeting", date: "" },
    { name: "Mobilization", date: "" },
    { name: "50% Completion", date: "" },
    { name: "75% Completion", date: "" },
    { name: "Construction Completion", date: "" },
  ],
};

export const ProjectSchedulesSlice = createSlice({
  name: "project-schedules",
  initialState,
  reducers: {
    setAcquisitionSchedule(state, { payload }) {
      state.acquisition[payload.index] = payload.value;
    },
    addAcquisitionSchedule(state, { payload }) {
      state.acquisition.push(payload);
    },
    deleteAcquisitionSchedule(state, { payload }) {
      state.acquisition = state.acquisition.filter((b, i) => i !== payload);
    },
    setFinanceSchedule(state, { payload }) {
      state.finance[payload.index] = payload.value;
    },
    addFinanceSchedule(state, { payload }) {
      state.finance.push(payload);
    },
    deleteFinanceSchedule(state, { payload }) {
      state.finance = state.finance.filter((b, i) => i !== payload);
    },
    setProcurementSchedule(state, { payload }) {
      state.procurement[payload.index] = payload.value;
    },
    addProcurementSchedule(state, { payload }) {
      state.procurement.push(payload);
    },
    deleteProcurementSchedule(state, { payload }) {
      state.procurement = state.procurement.filter((b, i) => i !== payload);
    },
    setDesignSchedule(state, { payload }) {
      state.design[payload.index] = payload.value;
    },
    addDesignSchedule(state, { payload }) {
      state.design.push(payload);
    },
    deleteDesignSchedule(state, { payload }) {
      state.design = state.design.filter((b, i) => i !== payload);
    },
    setDevelopmentSchedule(state, { payload }) {
      state.development[payload.index] = payload.value;
    },
    addDevelopmentSchedule(state, { payload }) {
      state.development.push(payload);
    },
    deleteDevelopmentSchedule(state, { payload }) {
      state.development = state.development.filter((b, i) => i !== payload);
    },
    setConstructionSchedule(state, { payload }) {
      state.construction[payload.index] = payload.value;
    },
    addConstructionSchedule(state, { payload }) {
      state.construction.push(payload);
    },
    deleteConstructionSchedule(state, { payload }) {
      state.construction = state.construction.filter((b, i) => i !== payload);
    },
  },
});

export const {
  setAcquisitionSchedule,
  addAcquisitionSchedule,
  deleteAcquisitionSchedule,
  setFinanceSchedule,
  addFinanceSchedule,
  deleteFinanceSchedule,
  setProcurementSchedule,
  addProcurementSchedule,
  deleteProcurementSchedule,
  setDesignSchedule,
  addDesignSchedule,
  deleteDesignSchedule,
  setDevelopmentSchedule,
  addDevelopmentSchedule,
  deleteDevelopmentSchedule,
  setConstructionSchedule,
  addConstructionSchedule,
  deleteConstructionSchedule,
} = ProjectSchedulesSlice.actions;
export default ProjectSchedulesSlice.reducer;
